<script setup lang="ts">
import RowGrid from '@/modules/Workspaces/KnowledgeHub/Hubs/FileTable/RowGrid.vue'
import IconSprite from '@/uiKit/IconSprite.vue'

defineProps<{ name: string; path: string; isExpanded: boolean }>()
</script>

<template>
  <RowGrid class="cursor-pointer rounded-lg hover:bg-background-transparent-hovered">
    <template #filename>
      <div
        data-tree-padded-cell
        class="relative flex h-full shrink grow items-center truncate select-none"
      >
        <IconSprite
          :icon="isExpanded ? 'open-folder' : 'folder'"
          size="lg"
          class="shrink-0 text-icon-subtlest"
        />
        <span class="mr-16 ml-1 w-full truncate">{{ name }}</span>
      </div>
    </template>
  </RowGrid>
</template>
